import { injectable, inject } from 'inversify'

import { RoutingService } from '#AltServices'

@injectable()
export class OrderRoutingService {
  constructor(@inject(RoutingService) readonly router: RoutingService) {}

  get index() {
    return this.router.createRouteData({ name: 'OrderIndex' })
  }

  get create() {
    return this.router.createRouteData({ name: 'OrderCreate' })
  }

  /** Mini App Orders tab root (`/orders`). */
  get ordersIndex() {
    return this.router.createRouteData({ name: 'OrdersIndex' })
  }

  getDetail(orderId: number) {
    return this.router.createRouteData({
      name: 'OrderDetail',
      params: { id: orderId },
    })
  }

  get profileIndex() {
    return this.router.createRouteData({ name: 'ProfileIndex' })
  }
}
